module.exports = __webpack_public_path__ + "c83b154c7ab72e3c0c425c0fc1ed89cd.png";